export enum PanelFieldType {
  TextField = 'TextField',
  JsonField = 'JsonField'
}
